import { styled } from '@mui/material';

export const StyledChipContainer = styled('span')({
  display: 'inline-block',
  verticalAlign: 'middle',
  position: 'absolute',
  left: '0.5rem',
  top: '50%',
  transform: 'translateY(-50%)',
});